import React from 'react';
import { Box, Typography, Container, Button, Stack } from '@mui/material';
import { SearchOff, Home, ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import PublicLayout from '../components/PublicLayout';
import { useAuth } from '../contexts/AuthContext';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  return (
    <PublicLayout>
      <Container maxWidth="sm">
        <Box
          sx={{
            minHeight: '60vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            py: 8,
          }}
        >
          <SearchOff sx={{ fontSize: 72, color: 'text.disabled', mb: 2 }} />
          <Typography variant="h2" component="h1" sx={{ fontWeight: 700, mb: 1 }}>
            404
          </Typography>
          <Typography variant="h5" sx={{ mb: 1 }}>
            Page not found
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            The page you're looking for doesn't exist or may have been moved.
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <Button variant="outlined" startIcon={<ArrowBack />} onClick={() => navigate(-1)}>
              Go Back
            </Button>
            {currentUser ? (
              <Button variant="contained" startIcon={<Home />} onClick={() => navigate('/app/dashboard')}>
                Go to Dashboard
              </Button>
            ) : (
              <Button variant="contained" startIcon={<Home />} onClick={() => navigate('/')}>
                Go to Homepage
              </Button>
            )}
          </Stack>
        </Box>
      </Container>
    </PublicLayout>
  );
};

export default NotFoundPage;
